import { Button, ButtonVariant } from '@egw/components'
import { DEFAULT_COUNTRY_CODE } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { formatPhoneNumber } from 'react-phone-number-input'
import { Logger } from '@egw/logger'
import { type UpdatePhoneStep, UpdatePhoneField } from '../../types/phone/phone-types'
import { getFullPhoneNumber } from '../../utils'

const log = new Logger('Confirm Phone Step')
export const ConfirmPhoneStep: FC<UpdatePhoneStep> = ({ closeModal }) => {
  const { t } = useTranslation('features-settings')

  const { getValues } = useFormContext()

  const phoneNumber = getValues(UpdatePhoneField.PHONE) as string

  const phone = formatPhoneNumber(
    getFullPhoneNumber({
      phoneNumber,
      countryPhoneCode: DEFAULT_COUNTRY_CODE,
    }),
  )

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4 items-center">
        <CheckCircleIcon height="17" width="17" className="fill-green-400" />
        <p className="text-textSuccess fs-exclude">{phone}</p>
      </div>
      <Button
        variant={ButtonVariant.Primary}
        id="doneUpdatePhone"
        onClick={() => {
          log.debug('Closing Modal')
          closeModal()
        }}
      >
        {t('settings.personal_info.change.done')}
      </Button>
    </div>
  )
}
